export type PasswordStrength = 'none' | 'weak' | 'fair' | 'strong' | 'very_strong';

export function getPasswordStrength(password: string): { level: PasswordStrength; score: number } {
  if (!password) return { level: 'none', score: 0 };
  if (password.length < 8) return { level: 'weak', score: 0 };
  let score = 1; // 8+ chars = 1 point
  if (/[A-Z]/.test(password)) score++;
  if (/[0-9]/.test(password)) score++;
  if (/[^A-Za-z0-9]/.test(password)) score++;
  const levels: PasswordStrength[] = ['weak', 'weak', 'fair', 'strong', 'very_strong'];
  return { level: levels[score], score };
}

export const STRENGTH_CONFIG: Record<Exclude<PasswordStrength, 'none'>, { label: string; color: string }> = {
  weak: { label: 'WEAK', color: '#ef4444' },
  fair: { label: 'FAIR', color: '#f59e0b' },
  strong: { label: 'STRONG', color: '#22c55e' },
  very_strong: { label: 'VERY STRONG', color: '#4ade80' },
};
